import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApplicationService } from '../../services/application.service';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-add-system-message',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Add New System Message</h4>
      <button type="button" class="btn-close close" (click)="close()"></button>
    </div>

    <div class="modal-body modal-body-touch">
      <div class="row">
        <div class="col text-center" style="font-size: 1em">
          <span class="fa fa-triangle-exclamation" style="color:red"></span>
          !!! This will add a system-wide broadcast message that <b>ALL</b> users will see when they log in. !!!
          <span class="fa fa-triangle-exclamation" style="color:red"></span>
          <br>
          Be aware of this scope when adding a new system message.
        </div>
      </div>

      <div class="row">
        <div class="col">
          <textarea [(ngModel)]="systemMessage" rows="10" style="height:100%;width:100%"></textarea>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="btn-group">
        <button [disabled]="systemMessage.length === 0" type="button" class="btn btn-danger dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          Post Message
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="postMessage(1)">Post for 1 hour</a></li>
          <li><a class="dropdown-item" (click)="postMessage(8)">Post for 8 hours</a></li>
          <li><a class="dropdown-item" (click)="postMessage(24)">Post for 1 day</a></li>
          <li><a class="dropdown-item" (click)="postMessage(72)">Post for 3 days</a></li>
          <li><a class="dropdown-item" (click)="postMessage(168)">Post for 1 week</a></li>
          <li><a class="dropdown-item" (click)="postMessage(720)">Post for 30 days</a></li>
        </ul>
      </div>
    </div>
  `
})
export class AddSystemMessageComponent {
  @Output() closeModal = new EventEmitter<void>();
  @Output() messageAdded = new EventEmitter<void>();

  systemMessage: string = '';

  constructor(
    private applicationService: ApplicationService,
    private toasterService: ToasterService
  ) {}

  postMessage(numHours: number): void {
    this.applicationService.addSystemMessage(this.systemMessage, numHours).subscribe({
      next: () => {
        this.toasterService.pop('success', 'System Message now active');
        this.messageAdded.emit();
        this.close();
      },
      error: (error) => {
        this.toasterService.pop('error', 'Error adding system message', error.message);
      }
    });
  }

  close(): void {
    this.closeModal.emit();
  }
}